export default __webpack_public_path__ + "images/license.b67af0ec.svg";